module.exports = __webpack_public_path__ + "static/indexCover-bf1a167f9e1b9d75c96905b2a1ccfa79.jpg";